module.exports = __webpack_public_path__ + "static/media/attendance.66deddad.png";